module.exports = __webpack_public_path__ + "static/media/img-ca57aec8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/logo/preptimize-logo.png
// module id = 5298
// module chunks = 39